import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../api';
import { fmtDate, toInputDate } from '../utils';
import { Badge, ActivityFeed } from '../components/ui';

export default function ContactDetail() {
  const { id } = useParams(); const navigate = useNavigate();
  const [contact, setContact] = useState(null); const [loading, setLoading] = useState(true);
  useEffect(() => { api.get(`/contacts/${id}`).then(r => setContact(r.data)).catch(() => navigate('/contacts')).finally(() => setLoading(false)); }, [id]);
  if (loading) return <div style={{ padding:40,color:'var(--gray-400)' }}>Loading...</div>;
  if (!contact) return null;
  return (
    <>
      <div className="page-header">
        <div>
          <Link to="/contacts" className="detail-back">← Contacts</Link>
          <div style={{ display:'flex',alignItems:'center',gap:12 }}>
            <span className="page-title">{contact.first_name} {contact.last_name}</span>
            <Badge status={contact.relationship_strength} />
          </div>
          {contact.title && <div style={{ fontSize:13,color:'var(--gray-500)',marginTop:2 }}>{contact.title}{contact.account_name ? ` · ${contact.account_name}` : ''}</div>}
        </div>
      </div>
      <div className="page-body">
        <div className="detail-grid">
          <div className="card">
            <div className="card-header"><span className="card-title">Contact Details</span></div>
            <div className="card-body">
              <div className="info-grid">
                {[['Email', contact.email ? React.createElement('a',{href:`mailto:${contact.email}`},contact.email) : null],['Phone',contact.phone],['Title',contact.title],['Department',contact.department],['Account',contact.account_name ? React.createElement('span',{className:'td-link',style:{cursor:'pointer'},onClick:()=>navigate(`/accounts/${contact.account_id}`)},contact.account_name) : null],['Relationship',React.createElement(Badge,{status:contact.relationship_strength})],['Existing Customer',contact.existing_customer==='Yes'?React.createElement('span',{style:{color:'var(--success)',fontWeight:600}},'Yes'):'No'],['Owner',contact.owner_name],['Created',fmtDate(contact.created_at)]].map(([label,val]) => (
                  <div key={label}><div className="detail-label">{label}</div><div className="detail-value">{val||'—'}</div></div>
                ))}
              </div>
              {contact.notes && React.createElement(React.Fragment,null,React.createElement('hr',{className:'divider'}),React.createElement('div',{className:'detail-label'},'Notes'),React.createElement('div',{className:'detail-value',style:{marginTop:4,whiteSpace:'pre-wrap'}},contact.notes))}
            </div>
          </div>
          <div className="card"><ActivityFeed relatedType="contact" relatedId={id} activities={contact.activities||[]} canContribute={true} /></div>
        </div>
      </div>
    </>
  );
}